import React from "react";
import { Dimmer, List, Loader } from "semantic-ui-react";

const ScrollableList = (props) => {
  const { loading, items, value, onClick } = props || {
    items: [],
    value: null,
    onClick: () => {},
    loading: false,
  };

  return (
    <div className="table-overflow flex-stretch-vertical" id="usersList">
      {loading ? (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      ) : (
        <List className="m-1">
          {items.map((item) => (
            <List.Item
              className="p-half clickable"
              key={item.key}
              active={value === item.value}
              onClick={() => onClick(item)}
            >
              <b>{item.text}</b>
            </List.Item>
          ))}
        </List>
      )}
    </div>
  );
};

export default ScrollableList;
